import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";

export const AvantiCardRunsContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "purchase_order_master",
        transformId: "avanti_card_runs",
        folder: "outputs",
        title: "Avanti Card Runs",
        dateHierarchyColumnFilter: {
          purchase_order_week: "PO week",
          purchase_order_month: "PO month",
          eta_to_warehouse_week: "ETA week",
          eta_to_warehouse_month: "ETA month",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: null,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Download,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
        ],
        paramsToTransformArgs,
        tableType: "flat",
      }}
      defaultConfig={defaultConfig}
    />
  );
};
